import React, {Component} from "react";
import {withNamespaces} from "react-i18next";

class DaliHelvarGroupForm extends Component {

    state = {
        form: {
            id: null,
            networkDeviceId: null,
            label: null,
            description: null,
            groupNumber: null,
            daliHelvarAreaId: null
        },
        isEdit: false
    };

    componentDidMount() {
        if(!this.props.data) {
            this.setState({
                ...this.state,
                form: {
                    ...this.state.form,
                    networkDeviceId: parseInt(this.props.deviceId),
                    daliHelvarAreaId: parseInt(this.props.daliHelvarAreaId)
                }
            })
        }

        if(this.props.data) {
            const { data } = this.props;
            this.setState({
                ...this.state,
                isEdit: true,
                form: {
                    id: data.id,
                    networkDeviceId: data.networkDeviceId,
                    label: data.label,
                    description: data.description,
                    groupNumber: data.groupNumber,
                    daliHelvarAreaId: data.daliHelvarAreaId
                }
            });
        }
    }

    handleOnChangeInput = (e) => {
        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                [e.target.name]: e.target.value
            }
        });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.submitForm(this.state.form);
    };

    render() {
        const { t } = this.props;

        return (
            <div>
                <form onSubmit={this.handleSubmit}>
                    <div className="form-group">
                        <label className="col-form-label">{t('group-number')}</label>
                        <input
                            className='form-control'
                            name="groupNumber"
                            title="groupNumber"
                            value={this.state.form.groupNumber || ''}
                            onChange={this.handleOnChangeInput}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label className="col-form-label">{t('label')}</label>
                        <input
                            className='form-control'
                            name="label"
                            title="label"
                            value={this.state.form.label || ''}
                            onChange={this.handleOnChangeInput}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label className="col-form-label">{t('description')}</label>
                        <textarea
                            className='form-control'
                            name="description"
                            title="description"
                            value={this.state.form.description || ''}
                            onChange={this.handleOnChangeInput}
                        />
                    </div>
                    <div className="form-group float-right">
                        { this.state.isEdit ? (
                            <button type="submit" className={"btn btn-primary" }>
                                <i className="fas fa-edit"> </i> {t('edit')}
                            </button>
                        ) : (
                            <button type="submit" className={"btn btn-success" }>
                                <i className="fas fa-plus"> </i> {t('create')}
                            </button>
                        ) }
                    </div>
                </form>
            </div>
        )
    }
}
export default withNamespaces()(DaliHelvarGroupForm)
